import { UrlApi } from "../../../../services/apirest";

export const getPagosDB = async (medio, desde, hasta, sucursalId) => {
  const medios= [11,12,13]
  try {
    const mediosStr = Array.isArray(medios) ? medios.join(',') : medios;
    const url = `${UrlApi}/envasado_pagos_combinados/pagosresumen/${mediosStr}/${desde} 00:00:00/${hasta} 23:59:59/${sucursalId}`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();    
    return data;
    
  } catch (error) {
    console.error('Error en getPagosDB:', error);
    throw error;
  }
};

export const getResumenPagosSucursal = async (sucursalId, desde, hasta) => {
  try {
    
    const url = `${UrlApi}/envasado_pagos_combinados/resumensucursal/${sucursalId}/${desde} 00:00:00/${hasta} 23:59:59`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
    
  } catch (error) {
    console.error('Error en getResumenPagosSucursal:', error);
    throw error;
  }
};

export const getCtaCte = async (sucursalId, desde, hasta) => {
  try {
    
    const url = `${UrlApi}/envasado_pagos_combinados/ctactesucursal/${sucursalId}/${desde} 00:00:00/${hasta} 23:59:59`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
    
  } catch (error) {
    console.error('Error en getCtaCte:', error);
    throw error;
  }
};